<header
  class="ul-app-header uls no-print"
  id="topbar"
  role="presentation"
  [attr.aria-label]="'header.aria.global_navigation' | translate"
>
  <div class="ul-app-header__left">
    <div class="ul-app-header__logo"></div>
    <span class="ul-app-header__separator"></span>
    <a [routerLink]="['/']">
      <h1 class="ul-app-header__appname">
        {{ 'header.app_name' | translate }}
      </h1>
    </a>
    @if (!screenService.isHandset()) {
      <nav class="top-level-nav" [attr.aria-label]="'header.aria.primaryNavigation' | translate">
        <button
          comp-button="tertiary"
          [class.active]="activeTopLevelComponent() == 'dashboard'"
          [routerLink]="['/dashboard']"
        >
          {{ 'header.sections.home' | translate }}
        </button>
        <button
          comp-button="tertiary"
          [class.active]="activeTopLevelComponent() == 'products'"
          [routerLink]="['/products']"
        >
          {{ 'header.sections.products' | translate }}
        </button>
      </nav>
    } @else {
      <button
        type="button"
        comp-button="secondary"
        class="top-level-nav-menu-trigger"
        [class.active]="
          activeTopLevelComponent() == 'dashboard' || activeTopLevelComponent() == 'products'
        "
        [matMenuTriggerFor]="topLevelNavMenu"
        [attr.aria-label]="'header.aria.openPrimaryNavigation' | translate"
      >
        <span>
          @if (activeTopLevelComponent() == 'products') {
            {{ 'header.sections.products' | translate }}
          } @else {
            {{ 'header.sections.home' | translate }}
          }
        </span>
        <i comp-icon>expand_more</i>
      </button>

      <mat-menu #topLevelNavMenu="matMenu" class="top-level-nav-menu">
        <button
          class="menu-item"
          mat-menu-item
          type="button"
          [class.active]="activeTopLevelComponent() == 'dashboard'"
          [routerLink]="['/dashboard']"
        >
          {{ 'header.sections.home' | translate }}
        </button>
        <button
          class="menu-item"
          mat-menu-item
          type="button"
          [class.active]="activeTopLevelComponent() == 'products'"
          [routerLink]="['/products']"
        >
          {{ 'header.sections.products' | translate }}
        </button>
      </mat-menu>
    }
  </div>
  <div class="ul-app-header__center"></div>

  <div class="ul-app-header__right">
    @if (loginResponse(); as lr) {
      @if (lr.isAuthenticated) {
        <button (click)="askAnExpert()" type="button" comp-button="secondary">
          <i comp-icon>question_answer</i>
          @if (!screenService.isHandset()) {
            <span>{{ 'askAnExpert.singular' | translate }}</span>
          }
        </button>
        <comp-notification></comp-notification>
        <div class="ul-avatar -small" [matMenuTriggerFor]="userMenu">
          {{ lr.userData?.givenName[0] + lr.userData?.surname[0] }}
        </div>

        <mat-menu #userMenu="matMenu" class="user-menu">
          <div class="user-menu__header" (click)="$event.stopPropagation()">
            <strong class="user-menu__name">
              {{ lr.userData?.givenName }} {{ lr.userData?.surname }}
            </strong>
            <span class="user-menu__manufacturer">
              @if (manufacturer(); as manufacturer) {
                {{ manufacturer.legalEntityName }}
              } @else {
                {{ lr.userData?.org }}
              }
            </span>
          </div>

          <mat-divider class="menu-divider"></mat-divider>

          @if (showLanguageSelector()) {
            <div class="user-menu__language" (click)="$event.stopPropagation()">
              <label id="user-language-label" for="user-language-select">
                {{ 'general.language' | translate }}
              </label>
              <mat-select
                id="user-language-select"
                aria-labelledby="user-language-label"
                [value]="selectedLanguage()"
                (selectionChange)="changeLanguage($event.value)"
              >
                @for (language of languageOptions(); track language.code) {
                  <mat-option [value]="language.code">{{ language.label }}</mat-option>
                }
              </mat-select>
            </div>

            <mat-divider class="menu-divider"></mat-divider>
          }

          <button class="menu-item" mat-menu-item type="button" (click)="openManufacturerDetails()">
            <div class="icon-and-text">
              <i comp-icon>manage_accounts</i>
              <span translate="manufacturer.manufacturerDetails"></span>
            </div>
          </button>
          @if (lr.isAuthenticated && lr.userData?.org == adminOrg()) {
            <button class="menu-item" mat-menu-item type="button" (click)="switchTenant.emit()">
              <div class="icon-and-text">
                <i comp-icon>sync_alt</i>
                <span translate="general.switchTenant"></span>
              </div>
            </button>
          }
          @if (lr.isAuthenticated) {
            <button class="menu-item" mat-menu-item type="button" (click)="openAbout()">
              <div class="icon-and-text">
                <i comp-icon>info</i>
                <span translate="general.about"></span>
              </div>
            </button>
          }
          <button class="menu-item" mat-menu-item type="button" (click)="onPrivacyNoticeClick()">
            <div class="icon-and-text">
              <i comp-icon>privacy_tip</i>
              <span translate="general.privacyNotice"></span>
            </div>
          </button>
          <mat-divider class="menu-divider"></mat-divider>
          <button class="menu-item" mat-menu-item type="button" (click)="logout.emit()">
            <div class="icon-and-text">
              <i comp-icon>logout</i>
              <span translate="general.signOut"></span>
            </div>
          </button>
        </mat-menu>
      } @else {
        <button comp-button="secondary" (click)="login.emit()" type="button">
          <i comp-icon size="medium">login</i>
          <span>{{ 'general.signIn' | translate }}</span>
        </button>
      }
    } @else {
      <progress class="ul-spinner -small"></progress>
    }
  </div>
</header>
